import "./about.css";

export default function About() {

  return (
    <div className="about-page">

      {/* HERO */}
      <section className="about-hero">

        <div className="about-overlay">

          <h1>Welcome To Apple Smoke Shop</h1>

          <p>
            Premium smoke shop products, grinders, pre-rolls,
            vapes, accessories, THCa products and more.
          </p>

        </div>

      </section>

      {/* ABOUT */}
      <section className="about-section">

        <div className="about-card">

          <h2>Who We Are</h2>

          <p>
            Apple Smoke Shop is your trusted destination for premium
            smoke shop products. We focus on quality products,
            affordable prices, and fast shipping to deliver the
            best customer experience possible.
          </p>

        </div>

        <div className="about-card">

          <h2>Our Mission</h2>

          <p>
            Our mission is to provide top-quality smoke accessories,
            grinders, vapes, pre-rolls, and lifestyle products while
            maintaining premium customer support and secure shopping.
          </p>

        </div>

      </section>

      {/* FEATURES */}
      <section className="features-section">

        <div className="feature-box">
          <h3>🔥 Premium Quality</h3>
          <p>Carefully selected premium smoke shop products.</p>
        </div>

        <div className="feature-box">
          <h3>🚚 Fast Shipping</h3>
          <p>Quick and secure shipping across the United States.</p>
        </div>

        <div className="feature-box">
          <h3>🔒 Secure Payments</h3>
          <p>Safe checkout and trusted payment methods.</p>
        </div>

        <div className="feature-box">
          <h3>💨 Smoke Shop Experts</h3>
          <p>Products chosen by passionate smoke shop enthusiasts.</p>
        </div>

      </section>

      {/* CTA */}
      <section className="about-cta">

        <h2>Explore Premium Smoke Products</h2>

        <p>
          Upgrade your smoke experience with premium accessories and products.
        </p>

        <a href="/" className="shop-btn">
          Shop Now
        </a>

      </section>

    </div>
  );
}